/* Behaviour for the shared header and footer (snippets/rockkt-chrome-head-v1
   and rockkt-chrome-foot-v1). v1.

   Three things, each of which every hand-built template used to wire up for
   itself in its own inline script:

     the burger          opens and closes #navMobile
     back to top         the round button in the footer
     the newsletter box  posts to Shopify's own /contact endpoint, exactly as
                         the footer on Request an invite does, so a subscribe
                         from here lands in the same inbox in the same format

   ONLY BINDS INSIDE .rk-chrome, and marks what it has bound. A template that
   still carries its own burger script must have that script removed when it
   moves to the shared header: two click handlers on one burger open the menu
   and close it again in the same tick, and it looks broken with nothing in
   the console. Contact's was taken out when it moved.

   The logo needs nothing from here. <img data-media="m0"> is painted by
   rockkt-logo-paint-v1.css and pointed at the asset by rockkt-logo-v3.js, both
   loaded from the layout, so rockkt-media.js (1.4MB) is not loaded for it. */
(function () {
  function once(el, key) {
    if (!el || el.getAttribute('data-rk-chrome') === key) return false;
    el.setAttribute('data-rk-chrome', key);
    return true;
  }

  function burger() {
    var btn = document.querySelector('header.rk-chrome .hamburger');
    var menu = document.querySelector('header.rk-chrome .nav-mobile');
    if (!btn || !menu || !once(btn, 'burger')) return;
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    /* Delegated, because the Features group is added to this menu later by
       rockkt-nav-features-v3.js and its links need to close it too. */
    menu.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) {
        menu.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function backTop() {
    var bt = document.querySelector('footer.rk-chrome .foot-top-btn');
    if (!once(bt, 'top')) return;
    bt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function newsletter() {
    var form = document.querySelector('footer.rk-chrome .foot-news');
    if (!once(form, 'news')) return;
    var field = form.querySelector('input[type="email"]');
    if (!field) return;

    /* Honeypot: a field no person can see or tab to. A bot that fills every
       input fills this one, and the post is dropped. */
    var trap = document.createElement('input');
    trap.type = 'text';
    trap.name = 'url';
    trap.tabIndex = -1;
    trap.setAttribute('autocomplete', 'off');
    trap.setAttribute('aria-hidden', 'true');
    trap.style.cssText = 'position:absolute;left:-9999px;top:auto;width:1px;height:1px;opacity:0;pointer-events:none';
    form.appendChild(trap);

    function post(fields) {
      if (trap.value) return;
      try {
        var body = ['form_type=contact', 'utf8=%E2%9C%93'];
        for (var k in fields) body.push('contact[' + encodeURIComponent(k) + ']=' + encodeURIComponent(fields[k] || ''));
        fetch('/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.join('&')
        });
      } catch (e) {}
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = field.value.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        post({ email: v, 'Request type': 'Newsletter subscribe', body: 'New newsletter subscriber from the site footer.' });
        form.innerHTML = '<span class="fn-done"><svg class="icn" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>You’re in. Watch your inbox.</span>';
      } else {
        field.focus();
        field.style.borderColor = '#e05a5a';
      }
    });
    field.addEventListener('input', function () { field.style.borderColor = ''; });
  }

  function run() { burger(); backTop(); newsletter(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
